import {SUCCESS} from "../../../../constants/action-postfix";
import {SUMM_GRADUATES_ORIENTATION_REQUEST} from "../summGraduatesOrientationReducer";


const initialState = null;

export const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${SUMM_GRADUATES_ORIENTATION_REQUEST}${SUCCESS}`: {
            return action.payload;
        }
        default:
            return state;
    }
};